import React from 'react';
import type { STEPS } from '@cencosud-cencommerce/paris-login';
import { MAIN_STEPS } from '@cencosud-cencommerce/paris-login';
import { Icon, Text } from '@cencosud-cencommerce/paris-uikit';

import { SendCustomerDataEvents } from '@/modules/shared/utils/gtmEvents';
import {
  CustomerDataEventInteractiveActions,
  CustomerDataEventInteractiveCategories,
  CustomerDataEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/customerDataTypes';

interface Props {
  setIsOpenOrStep: React.Dispatch<React.SetStateAction<boolean | STEPS>>;
}

const GiftCardInformation = ({ setIsOpenOrStep }: Props) => {
  const handleLoginButton = () => {
    setIsOpenOrStep(true);

    SendCustomerDataEvents.sendEvent({
      event: 'baseEvent',
      extraFields: {
        'event-interactive-category':
          CustomerDataEventInteractiveCategories.Checkout,
        'event-interactive-accion':
          CustomerDataEventInteractiveActions.ClickLink,
        'event-interactive-tag': CustomerDataEventInteractiveTags.LogIn
      }
    });
  };

  const handleCreateAccountButton = () => {
    setIsOpenOrStep(MAIN_STEPS.SIGN_UP);

    SendCustomerDataEvents.sendEvent({
      event: 'baseEvent',
      extraFields: {
        'event-interactive-category':
          CustomerDataEventInteractiveCategories.Checkout,
        'event-interactive-accion':
          CustomerDataEventInteractiveActions.ClickLink,
        'event-interactive-tag': CustomerDataEventInteractiveTags.CreateAccount
      }
    });
  };

  return (
    <div className="co-flex co-items-center co-flex-wrap co-gap-1">
      <Icon name="il-payment-methods" />
      <Text variant="body1" weight={600}>
        ¿Pagas con Gift Card?
      </Text>
      <Text weight={500}>Necesitas</Text>
      <Text
        variant="link1"
        color="primary-500"
        weight={600}
        onClick={handleLoginButton}
      >
        Iniciar sesión
      </Text>
      <Text weight={500}>o</Text>
      <Text
        variant="link1"
        color="primary-500"
        weight={600}
        onClick={handleCreateAccountButton}
      >
        Crear una cuenta
      </Text>
    </div>
  );
};

GiftCardInformation.displayName = 'GiftCardInformation';

export default GiftCardInformation;
